<script>
	import { beforeUpdate } from 'svelte';

	import Icons from '../components/icons.svelte';

	import Card from './card.svelte';

	import textfit from 'textfit';

	const GUESS = 'guess';
	const TOGGLE_CARD = 'toggleCard';

	export let cards;
	export let showGuessButton;
	export let forceStopAudio;
	export let isAuthGiver;

	beforeUpdate (() => {
		doTextFit();
	});

	let debounceTimeout;
	function doTextFit() {
		const ms = 500;
		clearTimeout(debounceTimeout);
		debounceTimeout = setTimeout(() => textfit(document.getElementsByClassName('word'), { reProcess: true, detectMultiLine: false, maxFontSize: 22 }), ms);
		// textfit(document.getElementsByClassName('word'), { reProcess: true, detectMultiLine: false, maxFontSize: 22 })
	}

	let highlightOwn = false;

	// $: if (cards) {
	// 	console.log('!!!!!&&&&&&&');
	// 	doTextFit();
	// }

/*
	const songs = [
		{
			artist: 'Kalei Gamiao',
			path: '/sounds/uke/songs/coldplay-viva_la_vida.mp3',
			sourceLink: 'https://youtu.be/b5zuxnr-rJQ',
			composer: 'Coldplay',
			song: 'Viva la Vida'
		},
		{
			artist: 'Ukulele Cheats',
			path: '/sounds/uke/songs/cranberries-zombie.mp3',
			sourceLink: 'https://youtu.be/iRQxhrNOnMQ',
			composer: 'Cranberries',
			song: 'Zombie'
		},
		{
			artist: 'Al Wood',
			path: '/sounds/uke/songs/guns_n_roses-sweet_child_o_mine.mp3',
			sourceLink: 'https://youtu.be/jH15OohMVww',
			composer: `Guns N' Roses`,
			song: `Sweet Child O' Mine`
		},
		{
			artist: 'Ukes of Hazzard',
			path: '/sounds/uke/songs/metallica-one.mp3',
			sourceLink: 'https://youtu.be/n8RBrw5pGWg',
			composer: `Metallica`,
			song: `One`
		},
		{
			artist: 'Al Wood',
			path: '/sounds/uke/songs/pixies-where_is_my_mind.mp3',
			sourceLink: 'https://youtu.be/YEpWJSQH-Yo',
			composer: `Pixies`,
			song: `Where is My Mind`
		},
		{
			artist: 'Sebaraedo',
			path: '/sounds/uke/songs/radiohead-karma_police.mp3',
			sourceLink: 'https://youtu.be/Uk5z8Bku2O8',
			composer: `Radiohead`,
			song: `Karma Police`
		},
		{
			artist: 'Al Wood',
			path: '/sounds/uke/songs/radiohead-no_surprises.mp3',
			sourceLink: 'https://youtu.be/jZKshAq96MM',
			composer: `Radiohead`,
			song: `No Surprises`
		},
		{
			artist: 'Al Wood',
			path: '/sounds/uke/songs/u2-one.mp3',
			sourceLink: 'https://youtu.be/Poub-X8RD9o',
			composer: `U2`,
			song: `One`
		}
	].sort((a, b) => Math.round(Math.random()) ? 1 : -1);
	function onEnded(e) {
		if (curretnIndex >= songs.length - 1) {
			curretnIndex = 0;
		}
		else {
			curretnIndex++;
		}
		audioRef.setAttribute("src", curretnTrack.path);
		audioRef.load();
	}
			*/
/*
	let isPlaying = false;
	let playAnother = false;
	function playForAMoment() {
		if (forceStopAudio || !audioRef) {
			return;
		 }
		 if (isPlaying) {
			 playAnother = true;
			 return;
		 }
		 isPlaying = true;
		 audioRef.play();
		 setTimeout(() => {
			 isPlaying = false;

			 if (playAnother) {
				 playAnother = false;
				 playForAMoment();
			 }
			 else {
				 audioRef.pause();
			 }
		 }, 100);
	}
*/
</script>

<svelte:window on:resize={doTextFit}/>

<!--
<audio
	controls
	src={curretnTrack.path}
	tabindex="0"
	preload="auto"
	on:ended={onEnded}
	bind:this={audioRef}>
</audio>
-->
<div class="board">
	{#each cards as card (card.position+card.word)}
		<Card
			{...card}
			{showGuessButton}
			{forceStopAudio}
			{highlightOwn}
			on:toggleCard

			{GUESS}
			{TOGGLE_CARD}

			on:guess
			on:hoveringOff
			on:hoveringOn
		/>
	{/each}
</div>

<div
	class="highlight-own"
	tabindex="0"
	title="show your cards"
	on:focusin={() => highlightOwn = true}
	on:focusout={() => highlightOwn = false}
	on:mouseenter={() => highlightOwn = true}
	on:mouseleave={() => highlightOwn = false}>

	<span class="highlight-own-icon">
		<Icons name="eye" size="2em" strokeWidth="0.2em" strokeColor="rgba(0,0,0,0.5)" animateDraw={false}/>
	</span>
</div>

<style lang="less">
	.board {
		display: grid;
		width: 100%; height: 100%;
		grid-template-columns: repeat(5, calc(20% - 4vmin / 5));
		grid-template-rows: repeat(5, calc(20% -  4vmin / 5));
		grid-gap: 1vmin 1vmin;
		justify-self: center;
	}

	.highlight-own {
		position: absolute;
		margin: 2em;
		padding: 0 0.2em;
		line-height: 0;
		background: rgba(255,255,255,0.5);
		border-radius: 50%;
		z-index: 11;
	}
</style>